// extracted by mini-css-extract-plugin
export default {"container":"style_container__wvdir","text":"style_text__GIajy","subText":"style_subText__lGAjc"};